import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=a9bbc28a"
import script from "./tag.js?vue&type=script&lang=js&external"
export * from "./tag.js?vue&type=script&lang=js&external"
import style0 from "./tag.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports